import React,{useState}  from 'react';

const materials = ["PMMA","Graphenano","PFM","PFZ","Monolythic Zirconia"];
const overDentureMaterials = ["PMMA","PMMA + Vitalium mesh"];

const MaterialPanel = (props)=>{

    const {
        materialsState,
        changeMaterial,
        type
    } = props;

    const [curMaterial,changeCurMaterial] = useState(null);

    const materialChanged = (material)=>{
        changeMaterial(curMaterial);
        changeCurMaterial(null);
    }

    const showMaterials = (materialsState === "show-materials");
    const isOverDenture = type === 2;
    const materialsToShow = isOverDenture? overDentureMaterials:materials;

    return(
        <div className='abra-materials panel'>
            <h4>{abraStr.material}</h4>

                { showMaterials &&
                <div className={`items ${isOverDenture? "over-denture" : ""}`}>
                    {materialsToShow.map((item, index) =>
                        <div
                            key={index}
                            className={curMaterial === item ? "on" : ""}
                            onClick={() => {
                                changeCurMaterial(item)
                            }}
                        >
                            <span>{item}</span>
                        </div>
                    )}
                    <div
                        key="choose"
                        className={`choose ${curMaterial? "active": ""}`}
                        onClick={() => {
                            if(curMaterial) materialChanged(curMaterial)
                        }}
                    >
                        <span>{abraStr.done}</span>
                    </div>
                </div>
                }

             {!showMaterials &&
                <div className={`no-items ${materialsState}`}>
                    <div>
                        {
                            materialsState === "no-type"? abraStr.firstSelect : abraStr.selectTeeth}
                    </div>
                </div>
            }
        </div>
    );
}

export default MaterialPanel;